import { useUser } from '~/@biz_account/useUser/useUser'
import { FaceIconSmiley } from '~/@mid_ui/icons/FaceIconSmiley'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'

function InvestorSignatureSideProgress() {
  const isDesktop = useIsDesktop()
  const { user } = useUser()

  const customContent = (() => {
    if (!isDesktop || !user?.profile.investorInfo) return null

    return <FaceIconSmiley />
  })()

  return <>{customContent}</>
}

export { InvestorSignatureSideProgress }
